import { createSelector } from 'reselect'

const activitySelector = (state, activityId) => state.game.activities.find(activity => activity.id === activityId)

export default createSelector(
	[ activitySelector],
	activity => activity
)
